import { createSelector } from 'reselect'
import playbackSpeedTypes from 'helpers/enums/interactiveVideo/playbackSpeedTypes'
import playbackSpeedsFormatter from 'helpers/interactive_video/playbackspeeds_formatter'

const getInteractiveVideo = state => state.interactiveVideo

export default createSelector(
	[ getInteractiveVideo ],
	interactiveVideo => {

		const availableSpeeds = [
			playbackSpeedTypes.FASTEST,
			playbackSpeedTypes.FAST,
			playbackSpeedTypes.NORMAL,
			playbackSpeedTypes.SLOW,
			playbackSpeedTypes.SLOWEST,
		]

		return playbackSpeedsFormatter(availableSpeeds, interactiveVideo.settings.selectedVideoPlaybackSpeed)
	}
)
